// extracted by mini-css-extract-plugin
export default {"root":"style_root__YAUMQ","content":"style_content__irzI6","spreadsheet":"style_spreadsheet__JCLND","reload":"style_reload__NNh4s"};